import { Models } from "@hex-insights/app-modules";
import { StudentNote, StudentNoteNoteType } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the noteType field of the StudentNote model.
 */
export function noteType(value: StudentNote["noteType"] | null): string {
	if (value === null) {
		return Models.toString(value);
	}

	switch (value) {
		case StudentNoteNoteType.Academic:
			return "Academic Note";
		case StudentNoteNoteType.Attendance:
			return "Attendance Note";
		case StudentNoteNoteType.Behavior:
			return "Behavior Report";
		case StudentNoteNoteType.General:
			return "General Note";
		case StudentNoteNoteType.Health:
			return "Health Note";
		case StudentNoteNoteType.Incident:
			return "Incident Report";
		case StudentNoteNoteType.Injury:
			return "Injury Report";
		case StudentNoteNoteType.Medication:
			return "Medication Note";
		case StudentNoteNoteType.SocialEmotional:
			return "Social/Emotional Report";
	}
}

/**
 * Formats the createdAt field of the StudentNote model.
 */
export function createdAt(value: StudentNote["createdAt"] | null): string {
	return ModelFormat.time(value);
}

/**
 * Formats the body field of the StudentNote model.
 */
export function body(value: StudentNote["body"]): string {
	return Models.toString(value);
}

/**
 * Formats the isPinned field of the StudentNote model.
 */
export function isPinned(value: StudentNote["isPinned"]): string {
	return Models.toString(value);
}

/**
 * Formats the requiresResolution field of the StudentNote model.
 */
export function requiresResolution(value: StudentNote["requiresResolution"]): string {
	return Models.toString(value);
}

/**
 * Formats the isResolved field of the StudentNote model.
 */
export function isResolved(value: StudentNote["isResolved"]): string {
	return Models.toString(value);
}

/**
 * Formats the resolvedAt field of the StudentNote model.
 */
export function resolvedAt(value: StudentNote["resolvedAt"] | null): string {
	return Models.toString(value);
}

/**
 * Formats the resolutionDescription field of the StudentNote model.
 */
export function resolutionDescription(value: StudentNote["resolutionDescription"]): string {
	return Models.toString(value);
}
